
import React from 'react'
import {
    List,
    Datagrid,
    Edit,
    Create,
    SimpleForm,
    DateField,
    TextField,
    ArrayField,
    SingleFieldList,
    EditButton,
    TextInput,
    DateInput,
    Responsive,
    SimpleList,
    SimpleShowLayout,
    ShowButton,
    Show,
    UrlField,
    SelectInput,
    Filter,
    useListContext,
    TopToolbar,
    CreateButton,
    ExportButton,
    Pagination,
    Button,
    ChipField,
    required,
    sanitizeListRestProps,
    SaveButton,
    DeleteButton,
    Toolbar,
    NumberInput,
    FileInput,
    FileField,
    translate,
    ImageField,
    ReferenceField,
    ReferenceInput,
    RichTextField,
    BooleanField,
    BooleanInput,
    AutocompleteInput,
    FunctionField,
} from 'react-admin'
import { cloneElement, useMemo } from 'react'
import PropTypes from 'prop-types'
import BookIcon from '@material-ui/icons/BookOutlined'
import RichTextInput from 'ra-input-rich-text';
import OptionalImageField from '../Customs/OptionalImageField'
import dataProvider from '../dataProvider'
import GalleryInput from '../Customs/GalleryInput'


const API_URL = process.env.REACT_APP_API_HOSTNAME

export const PostIcon = BookIcon

const Post_Filter = (props) => (
    <Filter {...props}>
        <TextInput source="title" options={{ maxLength: 1024 }} />
        <ReferenceInput source="website" reference="Website" perPage={10000} >
            <AutocompleteInput optionText="ndd" />
        </ReferenceInput>
    </Filter>
)

const ListActions_Store = {}

const ListActions = (props) => {
    const {
        className,
        exporter,
        filters,
        maxResults,
        ...rest
    } = props
    let {
        currentSort,
        resource,
        displayedFilters,
        filterValues,
        hasCreate,
        basePath,
        selectedIds,
        showFilter,
        total,
    } = useListContext()
    ListActions_Store.filterValues = filterValues
    return (
        <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
            {filters && cloneElement(filters, {
                resource,
                showFilter,
                displayedFilters,
                filterValues,
                context: 'button',
            })}
            <CreateButton basePath={basePath} />
        </TopToolbar>
    )
}

export const PostList = (props) => (
    <List {...props} filters={<Post_Filter />} actions={<ListActions />} perPage={10}>
        <Responsive
            small={
                <SimpleList linkType="show"
                    primaryText={record => record ? record.email : ''}
                />
            }
            medium={
                <Datagrid>
                    <TextField source="title" sortable={false} />
                    <TextField source="slug" sortable={false} />
                    <OptionalImageField source='image_url' sortable={false} />
                    <ReferenceField source="website" reference="Website" >
                        <TextField source="ndd" />
                    </ReferenceField>
                    <DateField source="publishedAt" sortable={false} />
                    <FunctionField label="Words Count" render={(record) => record.content.split('\n').join(' ').split(' ').filter(e => !!e).length} />
                    <BooleanField source="private" />
                    <DateField source="createdAt" showTime={true} sortable={true} />
                    <DateField source="updatedAt" showTime={true} sortable={true} />
                    <EditButton />
                    <ShowButton />
                </Datagrid>
            }
        />
    </List>
)


export const PostShow = (props) => (
    <Show {...props}>
        <SimpleShowLayout>
            <TextField source="title" />
            <TextField source="slug" />
            <TextField source='image' />
            <OptionalImageField source='image_url' />
            <ReferenceField source="website" reference="Website" >
                <TextField source="ndd" />
            </ReferenceField>
            <DateField source="publishedAt" />
            <BooleanField source="private" />
            <FunctionField label="Words Count" render={(record) => record.content.split('\n').join(' ').split(' ').filter(e => !!e).length} />
            <RichTextField source="content" />
            <DateField source="createdAt" showTime={true} />
            <DateField source="updatedAt" showTime={true} />
        </SimpleShowLayout>
    </Show>
)

const CustomToolBar = props => <Toolbar {...props} ><SaveButton /></Toolbar>

export const PostEdit = (props) => (
    <Edit {...props} undoable={false} toolbar={<CustomToolBar />} >
        <SimpleForm redirect="show">
            <TextInput source="title" validate={required()} />
            <TextInput source="slug" validate={[required()]} />
            <GalleryInput source="image" optionText="nameWithSize" />

            {/* <ReferenceInput source="image" reference="Media" validate={required()} perPage={10000} >
                <AutocompleteInput optionText="nameWithSize" />
            </ReferenceInput> */}
            <BooleanInput source="private" />
            <DateInput source="publishedAt" validate={required()} />
            <RichTextInput source="content" validate={required()} />
        </SimpleForm>
    </Edit>
)

export const PostCreate = (props) => (
    <Create {...props}>
        <SimpleForm redirect="show">
            <TextInput source="title" validate={required()} />
            <GalleryInput source="image" optionText="nameWithSize" />
            {/* <ReferenceInput source="image" reference="Media" validate={required()} perPage={10000} >
                <AutocompleteInput optionText="nameWithSize" />
            </ReferenceInput> */}
            <ReferenceInput source="website" reference="Website" validate={required()} >
                <AutocompleteInput optionText="ndd" />
            </ReferenceInput>
            <BooleanInput source="private" />
            <DateInput source="publishedAt" validate={required()} />
            <RichTextInput source="content" validate={required()} />
        </SimpleForm>
    </Create>
)

